import Box from '@mui/material/Box';

import { FileAttachment } from '~hooks/useFileAttachment/models';

import { columns, gridTemplateColumns } from './all-files-table-columns';
import ActionsColumn from './Columns/ActionsColumn';
import CategoryColumn from './Columns/CategoryColumn';
import DescriptionColumn from './Columns/DescriptionColumn';
import FileColumn from './Columns/FileColumn';
import UploadDateColumn from './Columns/UploadDateColumn';
import UploadedByColumn from './Columns/UploadedByColumn';

const rowGridColumn = `span ${columns.length}`;

interface TableRowProps {
  file: FileAttachment;
}

export default function TableRow({ file }: TableRowProps) {
  return (
    <Box
      sx={(theme) => ({
        borderBottom: `solid 1px ${theme.brandV2.colors.treadGray7}`,
        display: 'grid',
        gridAutoRows: '70px',
        gridColumn: rowGridColumn,
        gridTemplateColumns,
        overflow: 'hidden',
      })}
    >
      <FileColumn sx={{ ...columns[0].sx }} file={file} />
      <UploadDateColumn sx={{ ...columns[1].sx }} file={file} />
      <CategoryColumn sx={{ ...columns[2].sx }} file={file} />
      <UploadedByColumn sx={{ ...columns[2].sx }} file={file} />
      <DescriptionColumn sx={{ ...columns[2].sx }} file={file} />
      <ActionsColumn sx={{ ...columns[5].sx }} file={file} />
    </Box>
  );
}
